import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ButtonsConfiguration, InfoButtonConfiguration } from 'src/app/models/buttons-config';
import { PhysicalRecord } from 'src/app/models/physical-record';
import { Record } from 'src/app/models/record';
import { ConfigService } from 'src/app/services/config.service';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-physical-records-table',
  templateUrl: './physical-records-table.component.html',
  styleUrls: ['./physical-records-table.component.scss'],
})
export class PhysicalRecordsTableComponent implements OnInit {
  private static readonly MAX_DESKTOP_ITEMS = 10;
  private static readonly MAX_MOBILE_ITEMS = 4;

  private currentPaginationPage = 0;

  @Input() record: Record;
  @Input() physicalAvailabilityItems: PhysicalRecord[];

  @HostBinding('style.--header-items-length')
  get headerItemLength() {
    // Total length = headers.length + libraryName? + availability + end button
    return this.physicalRecordHeaders.length + (this.showLibraryCell ? 1 : 0) + 1 + 1;
  }

  buttonsConfig: ButtonsConfiguration;
  pageSize = PhysicalRecordsTableComponent.MAX_DESKTOP_ITEMS;
  physicalRecordHeaders: string[] = [];
  allRecordHeaders: string[] = [];
  physicalRecordsDisplayList: PhysicalRecord[] = [];
  physicalRecordHeadersToHide = [
    'libraryName',
    'availability',
    'recordId',
    'holdInfo',
    'previousHolds',
    'returnDate',
    'Reservas',
    'Pr\u00E9stamos',
    'Pr\u00E9stec'
  ];

  selectedItem: PhysicalRecord | null = null;
  isAllItemsDialogOpened = false;
  isInfoItemDialogOpened = false;
  showLibraryCell = true;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private configService: ConfigService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.buttonsConfig = new InfoButtonConfiguration(this.configService.get().showReturnLoanButton);
    this.allRecordHeaders = this.getHeaders();

    this.breakpointObserver.observe('(max-width: 1199px)').subscribe((breakpoint) => {
      // Mobile
      if (breakpoint.matches) {
        this.pageSize = PhysicalRecordsTableComponent.MAX_MOBILE_ITEMS;
        this.physicalRecordHeaders = [];
      } else { // Desktop
        this.pageSize = PhysicalRecordsTableComponent.MAX_DESKTOP_ITEMS;
        this.physicalRecordHeaders = this.getHeaders();
      }

      this.paginate();
    });
  }

  physicalPage(pagination: any) {
    this.currentPaginationPage = pagination?.pageIndex * pagination.pageSize;
    this.paginate();
  }

  openPhysicalRecordInfoDialog(physicalRecord: PhysicalRecord) {
    this.isInfoItemDialogOpened = true;
    this.selectedItem = physicalRecord;
  }

  private paginate() {
    this.physicalRecordsDisplayList = this.physicalAvailabilityItems.slice(this.currentPaginationPage, this.currentPaginationPage + this.pageSize);
  }

  private getHeaders() {
    let headers: string[] = [];

    // Para cada item del array busca sus cabeceras y añádelas al array si no estaban ya.
    // Entiendo que esto es así porque no todos los elementos pueden tener todas las cabeceras y
    // de esta forma nos aseguramos que todas las cabeceras estén incluídas. Si todos los elementos
    // tienen todas las cabeceras podríamos ahorrarnos el primer foreach y obtenerlas del primer elemento.
    this.physicalAvailabilityItems.forEach((item) => {
      const itemHeaders = Object.keys(item);

      itemHeaders.forEach((headerName) => {
        if (!headers.includes(headerName)) {
          headers.push(headerName);
        }
      });
    });

    this.showLibraryCell = headers.includes('libraryName');

    return headers.filter((key) => !this.physicalRecordHeadersToHide.includes(key));
  }
}
